import React from 'react';
import PropTypes from 'prop-types';

import Loading from '../Loading';
import ErrorBoundary from '../ErrorBoundary';

const FetchDataWrapper = (props) => {
  const {
    error,
    isFetching,
    fetched,
    children
  } = props;

  if (error) {
    return <ErrorBoundary hasError={!!error} />;
  }

  if (isFetching || !fetched) {
  // if (isFetching) {
    return <Loading isLoading />;
  }

  return <>{children}</>;
};

FetchDataWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  error: PropTypes.any, // TODO: define error types
  isFetching: PropTypes.bool,
  fetched: PropTypes.bool
};

export default FetchDataWrapper;
